<template>
  <div class="d-flex flex-column account-info mb-5 mb-lg-0">
    <Description class="mb-5 d-flex flex-column" />
    <Matches />
  </div>
</template>

<script>
import Description from '@/views/account/sidebarInfo/components/Description';
import Matches from '@/views/account/sidebarInfo/components/Matches';

export default {
  name: 'AccountInfoProfile',
  components: {
    Description,
    Matches,
  },
};
</script>
